import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { returnPath } from './return-path';

/**
 * Development only: with VITE_DEV_SUBJECT set, the app skips Keycloak and calls a local API running with
 * AUTH_MODE=dev (which the API refuses in production). import.meta.env.DEV is false in production builds.
 */
export const devSubject: string | undefined = import.meta.env.DEV ? import.meta.env.VITE_DEV_SUBJECT : undefined;

// Same Keycloak realm in development and production; override with VITE_OIDC_AUTHORITY if needed.
const authority = import.meta.env.VITE_OIDC_AUTHORITY ?? 'https://auth.syndiqia.com/realms/syndiqia';

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: 'syndiqia-web',
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  scope: 'openid profile email',
  // Session-scoped storage: closing the browser ends the session.
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
  onSigninCallback: (user) => {
    // Remove ?code=&state= from the address bar after the redirect back from Keycloak, and return to the page that
    // was asked for (Keycloak always comes back to "/"). The popstate event makes the router pick up the new path.
    window.history.replaceState({}, document.title, returnPath(user?.state) ?? window.location.pathname);
    window.dispatchEvent(new PopStateEvent('popstate'));
  },
};

/** Where to come back after signing in: the current page (passed to Keycloak as the sign-in state). */
export function signinState(): { returnTo: string } {
  return { returnTo: window.location.pathname + window.location.search + window.location.hash };
}

